import * as Pages from '../../pages';

import { VIEW_TYPES } from '../../constants/viewTypes';
import { ROUTE_ACCESS_TYPE } from '../../constants/routeAccessType';

export const upgradeRoutes = [
    {
        path: '/upgrade',
        route_access_type: ROUTE_ACCESS_TYPE.private,
        component: Pages.UpgradeSuccessPage,
        permissionRules: {
            availableViewTypes: [VIEW_TYPES.admin, VIEW_TYPES.client],
        },
    },
];
